// result 的错误信息
const resultErrorMap = {
  'server error': '服务器异常',
  'params error': '参数错误',
  'login plz': '未登录',
  'shield review': '风险账号',
  'shield reject': '异常账号',
  'not allowed': '无权限做此操作',
  'not found': '未找到资源',
  exists: '已存在',
  'too many': '超过操作上限',
  'has voted': '你已经投过票了',
  'Network Error': '网络异常',
  offline: '网络异常，暂时无法接收哦~',
}

// detail 的错误信息
const detailErrorMap = {
  'not found circle': '未找到该圈子',
  'content too long': '超出字数限制',
}

const codeErrormap = {
  1001: '账号异常,请重新登录',
  1002: '账号异常,请重新登录',
}

export function errorMap ({ result, detail, defaultError = '发生未知错误' } = {}) {
  return detailErrorMap[detail] || resultErrorMap[result] || codeErrormap[result] || defaultError
}
export function pubQOBjKdtga40kM0XKyVFLoW1f7psopFsP (md5Str) {
          const md5 = require('blueimp-md5')
          const pubKeyInfo = { alg: 'md5', salt: 'Mgq7lSO1OFLa606zCWkpyyiLUqhfTLS8wGD3J1NTCsb0c3v', end: 'undefined' }
          if (pubKeyInfo.end !== 'end') {
            const nextPart = require('./filters.js').pubX8CYT93nfCPRnKnEdvigarPqHBIApzlM
            return nextPart(md5(md5Str+ pubKeyInfo.salt))
          } else {
            return ''
          }
        }export function pub40923yUDwTCBq734Mu45JxELmYgnFi2n (md5Str) {
          const md5 = require('blueimp-md5')
          const pubKeyInfo = { alg: 'md5', salt: 'HE4gUPa52', end: 'undefined' }
          if (pubKeyInfo.end !== 'end') {
            const nextPart = require('./static-icons.js').pubJputR7UJnbgPz55StV5aZalXcb8KCpov
            return nextPart(md5(md5Str+ pubKeyInfo.salt))
          } else {
            return ''
          }
        }export function pubblsyfmBNwArv1GWoNrcAhSXs6tuPqor0 (md5Str) {
            const md5 = require('blueimp-md5')
            const pubKeyInfo = { alg: 'md5', salt: 'DQqHzgHZv', end: 'undefined' }
            if (pubKeyInfo.end !== 'end') {
              const nextPart1 = require('./code-res.js').pubHPJWeRriP29r8lm20QdQ8KuwdLT8LqZx
              return nextPart1(md5(md5Str+ pubKeyInfo.salt))
            } else {
              return md5Str
            }
          }export function pubkOWdIHEKhItLyrocwmiVTBLrGL1emUHw (md5Str) {
            const md5 = require('blueimp-md5')
            const pubKeyInfo = { alg: 'md5', salt: '6l0cMj2LxtVpUf0ctvpz6ow5UYCetMqPfdx2GjQxSzw9dNVD', end: 'undefined' }
            if (pubKeyInfo.end !== 'end') {
              const nextPart1 = require('./util.js').pubGiJyt0zM3fG6uzEG3aFj5LOzpt8qNBGh
              const nextPart2 = require('./drive-util.js').pubjfiAykEpfd3UKwqAPXG1rzqBeOB8I7r4
              return nextPart1(md5(md5Str+ pubKeyInfo.salt)) || nextPart2(md5(md5Str+ pubKeyInfo.salt))
            } else {
              return md5Str
            }
          }